// TODO: refactor env variables names ( use unified names )
export const environment = {
  production: true,
  version: "0.0.1 (beta)",
  graphql_endpoint: "https://test-rentalab-graph.fth.dev/graphql",
  url: "https://test-rentalab-file.fth.dev",
  skip_auth: false,
  REPORT_URL: "https://test-rentalab-report.fth.dev/download-report",
  routes_api_key: "REPLACE_ME",
  GOOGLE_SCRIPT: "https://maps.googleapis.com/maps/api/js",
  google_api_key: "REPLACE_ME",
  places_key: "REPLACE_ME",

  firebase: {
    apiKey: "REPLACE_ME",
    authDomain: "REPLACE_ME",
    projectId: "REPLACE_ME",
    storageBucket: "REPLACE_ME",
    messagingSenderId: "REPLACE_ME",
    appId: "REPLACE_ME",
    measurementId: "REPLACE_ME",
  },
  VAPIDKEY: "REPLACE_ME",
  RECAPTCHA_SITE_KEY: "REPLACE_ME",
  RECAPTCHA_SECRET_KEY: "REPLACE_ME",
  RECAPTCHA_API_URL: "https://www.google.com/recaptcha/api.js?render=explicit",
  REALTIME_SOCKET_URL: "https://test-rentalab-realtime.fth.dev",
  CRM_SOCKET_URL: "https://test-rentalab-crm.fth.dev",
  GEO_SERVICE_URL: "https://test-rentalab-geo.fth.dev",
  SHOW_SENTRY_REPORT_BUTTON: true,
  // Noleggiare's public online check-in form — opened in a new tab by the
  // save-time CTA on the customer ticket page.
  WEB_CHECKIN_URL: "https://www.noleggiare.it/it/webcheckin/",
};
